<template>
  <div id="register-setting-page">
    <div class="page-name">
      <div class="page-title">Role Manager</div>
    </div>
    <div class="page-container">
      <b-card class="w-100">
        <role-table
          :data="roles"
          :paginate="paginate"
          :onSetActive="onSetActive"
          :onUpdatePaginate="onUpdatePaginate"
          :onUpdateLimit="onUpdateLimit"
          :onDeleteData="onDeleteData"
        />
      </b-card>
      <br />
    </div>
  </div>
</template>

<script>
import RoleTable from '@/components/tables/RoleTable'
import { mapActions } from 'vuex'
import { ActionFetch } from '@/store/actionTypes'

export default {
  components: {
    'role-table': RoleTable,
  },
  data: () => ({
    enable: true,
    roles: [],
    paginate: {
      limit: 10,
      page: 1,
      totalPage: 1,
      totalRow: 0,
    },
  }),
  methods: {
    ...mapActions({
      getList: ActionFetch.ROLE.LIST,
      createData: ActionFetch.ROLE.CREATE,
      updateData: ActionFetch.ROLE.UPDATE,
      deleteData: ActionFetch.ROLE.DELETE,
    }),
    onDeleteData($data) {
      const h = this.$createElement

      const messageVNode = h('div', { class: 'text-center' }, [
        h('div', { class: 'text-center' }, [
          `If this role has been deleted, all user in this role has been delete permission too.`,
        ]),
        h('div', { class: 'text-center' }, [
          `Would you like to delete this role?`,
        ]),
      ])

      this.$bvModal
        .msgBoxConfirm(messageVNode, {
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'primary',
          headerClass: 'p-2 border-bottom-0',
          bodyClass: 'text-center',
          footerClass: 'p-2 border-top-0 justify-center',
          centered: true,
          okOnly: true,
        })
        .then(($conRes) => {
          if ($conRes) {
            this.deleteData($data.id).then(($res) => {
              if ($res.success) {
                this.paginate.page = 1
                this.fetchList(this.paginate.page)
              }
            })
          }
        })
    },
    onUpdatePaginate($paginate) {
      this.paginate.page = $paginate

      this.fetchList($paginate)
    },
    onUpdateLimit($limit) {
      this.paginate.limit = $limit
      this.paginate.page = 1
      this.fetchList()
    },
    onSetActive($data, $source) {
      $source.active = $data.value ? 1 : 0

      let dataSave = {
        id: $source.id,
        active: $source.active,
      }

      this.updateData(dataSave)
    },
    fetchList($page = 1) {
      const payload = {
        orderBy: 'id',
        direction: 'asc',
        limit: this.paginate.limit,
        page: $page,
      }

      this.getList(payload).then(($res) => {
        if ($res.success) {
          this.roles = $res.data
          this.paginate.totalPage = $res.dataLimit
            ? $res.dataLimit.totalPage
            : 1
          this.paginate.totalRow = $res.dataLimit
            ? $res.dataLimit.totalCount
            : 0
        }
      })
    },
  },
  created() {
    this.fetchList()
  },
}
</script>
